var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "portable-text"
  }, [_vm._l(_vm.processedBlocks, function (group, groupIndex) {
    return [group.type === "list" ? _c(group.listType === "bullet" ? "ul" : "ol", {
      key: "list-".concat(groupIndex),
      tag: "component",
      class: group.listType === "bullet" ? "bullet-list" : "numbered-list"
    }, _vm._l(group.items, function (block, itemIndex) {
      return _c("li", {
        key: block._key || itemIndex,
        class: "list-item level-".concat(block.level || 1)
      }, [_vm._l(block.children || [], function (child, childIndex) {
        return [child.marks && child.marks.length > 0 ? _c(_vm.getMarkComponent(child.marks[0], block), {
          key: "mark-".concat(child._key || childIndex),
          tag: "component",
          attrs: {
            value: _vm.getMarkValue(child.marks[0], block),
            text: child.text
          }
        }, [_vm._v(" " + _vm._s(child.text) + " ")]) : _c("span", {
          key: "text-".concat(child._key || childIndex)
        }, [_vm._v(_vm._s(child.text))])];
      })], 2);
    }), 0) : _c("div", {
      key: group.block._key || "block-".concat(groupIndex)
    }, [group.block._type !== "block" ? _c(_vm.getCustomComponent(group.block._type), {
      tag: "component",
      attrs: {
        value: group.block,
        index: groupIndex
      }
    }) : _c(_vm.getBlockComponent(group.block.style || "normal"), {
      tag: "component",
      attrs: {
        block: group.block,
        index: groupIndex
      }
    }, [_vm._l(group.block.children || [], function (child, childIndex) {
      return [child.marks && child.marks.length > 0 ? _c(_vm.getMarkComponent(child.marks[0], group.block), {
        key: "mark-".concat(child._key || childIndex),
        tag: "component",
        attrs: {
          value: _vm.getMarkValue(child.marks[0], group.block),
          text: child.text
        }
      }, [_vm._v(" " + _vm._s(child.text) + " ")]) : _c("span", {
        key: "text-".concat(child._key || childIndex)
      }, [_vm._v(_vm._s(child.text))])];
    })], 2)], 1)];
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };